import React from 'react'
import Header from './header'
import Footer from './footer'
import { site } from '../helpers'

export default function Layout({ children }) {
  return (
    <div className={site()}>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  )
}
